import { CommonHelper } from "../../../react-core/Helpers/CommonHelper";
import * as React from "react";
import { ClientAccountStore } from "../Stroes/Variable";
import { DatePicker } from "../../../react-core/Datepicker/DatePicker";
import { FormComponent } from "../../../react-core/Html/FormComponent";
import {
    PortfolioDashboardMultiSelectionStore,
    PortfolioDashboardStore,
} from "../Components/Clients/PortfolioDashboard/Store/Variable";
import { getSelectedAccountsInceptionDate } from "../Components/Clients/PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { HierarchyIdHelper } from "../../Shared/Common/HierarchyIdHelper";

interface IAsAtDatePickerProps extends React.Props<AsAtDatePicker> {
    selected: Date;
    accountViewSelected: string;
    onChange: (val: Date) => void;
    cssWrapper?: string;
}

interface IAsAtDatePickerState {}

export class AsAtDatePicker extends FormComponent<IAsAtDatePickerProps, IAsAtDatePickerState> {
    constructor(props: IAsAtDatePickerProps) {
        super(props);
        this.state = {};
    }

    private getLeastDate() {
        const { accountViewSelected } = this.props;
        const clientInfo = ClientAccountStore.getClientAccountInfo();
        let inceptionDate = new Date(1900, 1, 1);
        if (clientInfo) {
            if (
                !CommonHelper.isNullOrEmpty(accountViewSelected) &&
                HierarchyIdHelper.Equals(accountViewSelected, clientInfo.HierarchyId)
            ) {
                inceptionDate = new Date(clientInfo.InceptionDate as any);
            } else {
                const findObj = clientInfo.SubAccounts.filter((x) => x.HierarchyId == accountViewSelected)[0];
                if (findObj) {
                    inceptionDate = new Date(findObj.InceptionDate as any);
                }
            }
        } else {
            inceptionDate = getSelectedAccountsInceptionDate(
                PortfolioDashboardMultiSelectionStore.getData(),
                PortfolioDashboardStore.getData()
            );
        }

        return inceptionDate;
    }

    public render(): JSX.Element {
        const { selected } = this.props;
        const minDate = this.getLeastDate();
        const _dateDisable = false;
        const { cssWrapper } = this.props;

        return (
            <DatePicker
                disabled={_dateDisable}
                label="As at date"
                labelSRSufix="dd/mm/yyyy"
                required={"Can't be empty"}
                selected={selected ? (minDate >= selected ? minDate : selected) : selected}
                atLeast={{ value: minDate, errorMessage: "Date cannot be in the past" }}
                atMost={{ value: new Date(), errorMessage: "Date cannot be in the future" }}
                showYearDropdown={true}
                onChange={(d) => (d ? this.props.onChange(d) : null)}
                todayButton="Today"
                isClearable={true}
                isNotForm={true}
                dateFormat={"dd/MM/yyyy"}
                acceptDateFormats={["dd/MM/yyyy", "dd-MM-yyyy", "ddMMyyyy", "dd.MM.yyyy", "dd_MM_yyyy", "dd MM yyyy"]}
                acceptDateFormatsErrorMsg={"Incorrect date format. Enter as dd/mm/yyyy"}
                cssWrapper={cssWrapper}
            />
        );
    }
}
